// extracted by mini-css-extract-plugin
export default {"donationInputContainer":"E6Qgfp"};